export default "__VITE_ASSET__BVk1nS_v__"